import React, { useState } from 'react';
import './Product.css';
import assetUrl from '../../utils/assetUrl';

interface ProductItem {
  id: number;
  img:string;
  name: string;
  category: 'Men' | 'Women' | 'Unisex';
  price: string;
  description: string;
  imagePlaceholder: string; // Using colors or text for now if no images
}

const products: ProductItem[] = [
  {
    id: 1,
    img: assetUrl('/Prod_IMG/don-essential-day-cream.png'),
    name: "Essential Day Cream & After Shave",
    category: "Men",
    price: "29.00€",
    description: "Βασικό προϊόν αντρικής φροντίδας που συνδυάζει την δράση του After Shave και ενυδατικής κρέμας καθημερινής χρήσης.",
    imagePlaceholder: "#333",
  },
  {
    id: 2,
    img: assetUrl('/Prod_IMG/don_sea_salt_strong.png'),
    name: "Sea Salt Volumizing Hair Mist Strong",
    category: "Men",
    price: "25.00€",
    description: "Σπρέι διαμόρφωσης για τα μαλλιά. Δημιουργεί όγκο και υφή με φυσικό αποτέλεσμα. Ιδανικό για ατημέλητα looks.",
    imagePlaceholder: "#555",
  },
  {
    id: 3,
    img: assetUrl('/Prod_IMG/curl-creme-definer-200ml.png'),
    name: "Curl Creme Definer",
    category: "Men",
    price: "22.00€",
    description: "Κρέμα styling για καλοσχηματισμένες μπούκλες.",
    imagePlaceholder: "#777",
  },
  {
    id: 4,
    img: assetUrl('/Prod_IMG/don-dual-action-shaving-cream.png'),
    name: "Dual Action Shaving Cream & Face Wash",
    category: "Men",
    price: "19.50€",
    description: "Κρέμα ξυρίσματος και σαπούνι προσώπου με 98% φυσική σύνθεση.",
    imagePlaceholder: "#222",
  },
  {
    id: 5,
    img: assetUrl('/Prod_IMG/scalp-conditioner-325ml.png'),  
    name: "Scalp Remedy Conditioner",
    category: "Men",
    price: "26.50€",
    description: "Conditioner για μαλλιά με ευαίσθητο τριχωτό",
    imagePlaceholder: "#888",
  },
  {
    id: 6,
    img: assetUrl('/Prod_IMG/styling_creme_davroe.png'),
    name: "Styling Crème",
    category: "Men",
    price: "26.90€",
    description: "Πάστα για εύκαμπτο κράτημα με φυσικό φινίρισμα",
    imagePlaceholder: "#000",
  },
  {
    id: 7,
    img: assetUrl('/Prod_IMG/texture-clay-100g.png'),
    name: "Texture Clay",
    category: "Men",
    price: "25.50€",
    description: "Πηλός διαμόρφωσης για μέτριο κράτημα και ματ φινίρισμα",
    imagePlaceholder: "#000",
  },
  {
    id: 8,
    img: assetUrl('/Prod_IMG/don-gentle-beard-skin-lotion.png'),
    name: "Gentle Beard & Skin Lotion",
    category: "Men",
    price: "28.00€",
    description: "Κρέμα περιποίησης για τα γένια και το δέρμα.",
    imagePlaceholder: "#000",
  },
  {
    id: 9,
    img: assetUrl('/Prod_IMG/kyklos_toning.png'),
    name: "Kyklos Toning Shampoo",
    category: "Men",
    price: "19.50€",
    description: "Τονωτικό σαμπουάν για ευαίσθητο τριχωτό που μειώνει την τριχόπτωση",
    imagePlaceholder: "#000",
  },
  {
    id: 10,
    img: assetUrl('/Prod_IMG/defining_paste_davroe.png'),
    name: "Defining Paste",
    category: "Men",
    price: "26.90€",
    description: "Πάστα για δυνατό κράτημα με διάρκεια",
    imagePlaceholder: "#000",
  },
  {
    id: 11,
    img: assetUrl('/Prod_IMG/kyklos_intensity_sinergy.png'),
    name: "Kyklos Intensity Sinergy",
    category: "Men",
    price: "41.00€",
    description: "Θεραπεία ενίσχυσης και πρόληψης της φαλάκρας και της τριχόπτωσης",
    imagePlaceholder: "#000",
  },
  {
    id: 12,
    img: assetUrl('/Prod_IMG/fibre-cream.png'),
    name: "Fibre Creme",
    category: "Men",
    price: "25.50€",
    description: "Εύκαμπτος πηλός διαμόρφωσης με ινώδη υφή",
    imagePlaceholder: "#000",
  },
  {
    id: 13,
    img: assetUrl('/Prod_IMG/scalp-shampoo-325ml.png'),
    name: "Scalp Remedy Shampoo",
    category: "Men",
    price: "24.00€",
    description: "Θεραπευτικό σαμπουάν για το ευαίσθητο τριχωτό με προβλήματα",
    imagePlaceholder: "#000",
  },
  //front/build/Prod_IMG/scalp-remedy-spa-exfoliating-scrub.png
 /*  {
    id: 14,
    img: "/Prod_IMG/scalp-remedy-spa-exfoliating-scrub.png",
    name: "Scalp Remedy Spa Exfoliating Scrub",
    category: "Men",
    price: "33.70€",
    description: "Scrub απαλής απολέπισης και καθαρισμού του τριχωτού της κεφαλής",
    imagePlaceholder: "#000",
  },
  //front/build/Prod_IMG/davroe-scalp-remedy-brush.png
  {
    id: 15,
    img: "/Prod_IMG/davroe-scalp-remedy-brush.png",
    name: "Scalp Remedy Brush",
    category: "Men",
    price: "33.70€",
    description: "Ειδική βούρτσα που κάνει θεραπευτικό μασάζ και απολέπιση στο τριχωτό",
    imagePlaceholder: "#000",
  },
  //C:\Users\xaris\Documents\GitHub\MYFT_WEB\front\build\Prod_IMG\don-rich-beard-skin-lotion.png
  {
    id: 16,
    img: "/Prod_IMG/don-rich-beard-skin-lotion.png",
    name: "Rich Beard & Skin Lotion",
    category: "Men",
    price: "28.00€",
    description: "Κρέμα περιποίησης για τα γένια και το δέρμα.",
    imagePlaceholder: "#000",
  },
  //front/build/Prod_IMG/repair-shampoo-325ml_007ed625-8431-4510-8846-cf50dfcd8562.png
  {
    id: 17,
    img: "/Prod_IMG/repair-shampoo-325ml_007ed625-8431-4510-8846-cf50dfcd8562.png",
    name: "Repair Senses Revitalizing Shampoo",
    category: "Women",
    price: "25.50€",
    description: "Σαμπουάν για δυνατά μαλλιά με λαμπερό χρώμα που διαρκεί",
    imagePlaceholder: "#000",
  },
  //front/build/Prod_IMG/curlicue-activator-200ml.png
  {
    id: 18,
    img: "/Prod_IMG/curlicue-activator-200ml.png",
    name: "CURLiCUE Curl Activator", 
    category: "Women",
    price: "26.40€",
    description: "Σπρέι ενεργοποίησης που δίνει σχήμα στις μπούκλες",
    imagePlaceholder: "#000",
  },   */
];

const Product: React.FC = () => {
  const [filter, setFilter] = useState<'All' | 'Men' | 'Women'>('All');

  const filteredProducts = filter === 'All' 
    ? products 
    : products.filter(p => p.category === filter || p.category === 'Unisex');

  return (
    <div className="product-page">
      <div className="product-header">
        <h1>Τα Προϊόντα Μας</h1>
        <p>Premium περιποίηση για τα μαλλιά και το πρόσωπο.</p>
      </div>

      <div className="product-filters">
        <button 
          className={filter === 'All' ? 'active' : ''} 
          onClick={() => setFilter('All')}
        >
          Όλα
        </button>
        <button 
          className={filter === 'Men' ? 'active' : ''} 
          onClick={() => setFilter('Men')}
        >
          Ανδρικά
        </button>
        <button 
          className={filter === 'Women' ? 'active' : ''} 
          onClick={() => setFilter('Women')}
        >
          Γυναικεία
        </button>
      </div>

      <div className="product-grid">
        {filteredProducts.map(product => (
          <div key={product.id} className="product-cardPage">
            <div className="product-image"> 
              <img src={product.img} alt={product.name} />
            </div>
            <div className="product-details">
              <span className="product-category">{product.category}</span>
              <h3>{product.name}</h3>
              <p className="product-description">{product.description}</p>
              <div className="product-footer">
                <span className="product-price">{product.price}</span>
                
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Product;
